import { inject, Injectable, signal } from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/core/config/config-service';
import { Invite } from 'src/app/shared/models/invite.model';

@Injectable({
  providedIn: 'root'
})
export class InviteService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  /**
   * Akzeptiert alle Einladungen anhand der Authentifizierung.
   * @param id - ID der Einladung
   * @param type - Typ der Einladung (NectaOne oder VendorCatalog)
   * @returns Observable, das den Abschluss der Operation signalisiert.
   */
  acceptInvites(): Observable<Invite[]> {
    return this.http.post<Invite[]>(this.configService.getUrlVendorCatalogApi() + `/invites/accept`, {});
  }

}
